module.exports = __webpack_public_path__ + "img/netillac_logo.beee3194.png";